// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"595dfe1f","337":"773dbd87","355":"dee4021d","453":"657afc36","455":"c88bf32f"}[chunkId] + ".chunk.js";
};